import { z } from "zod";

export const CrmPackageMappingFormSchema = z
  .object({
    crmPackageId: z
      .string()
      .min(1, "CRM Package ID is required")
      .max(255, "CRM Package ID must be 255 characters or less"),

    action: z.enum(["map", "skip"]).default("map"),

    packageId: z.string().optional(),

    description: z.string().max(1000, "Description must be 1000 characters or less").optional(),
  })
  .refine(data => data.action === "skip" || (data.packageId && data.packageId.length > 0), {
    message: "Package is required when action is 'map'",
    path: ["packageId"],
  });

export type CrmPackageMappingFormData = z.infer<typeof CrmPackageMappingFormSchema>;

export function toApiCreateRequest(data: CrmPackageMappingFormData): {
  crmPackageId: string;
  action: "map" | "skip";
  packageId?: string;
  description?: string | null;
} {
  return {
    crmPackageId: data.crmPackageId,
    action: data.action,
    ...(data.action === "map" && data.packageId ? { packageId: data.packageId } : {}),
    description: data.description || null,
  };
}

export function toApiUpdateRequest(data: Partial<CrmPackageMappingFormData>): {
  crmPackageId?: string;
  action?: "map" | "skip";
  packageId?: string | null;
  description?: string | null;
} {
  const request: {
    crmPackageId?: string;
    action?: "map" | "skip";
    packageId?: string | null;
    description?: string | null;
  } = {};

  if (data.crmPackageId !== undefined) {
    request.crmPackageId = data.crmPackageId;
  }

  if (data.action !== undefined) {
    request.action = data.action;
    if (data.action === "skip") {
      request.packageId = null;
    }
  }

  if (data.packageId !== undefined && data.action !== "skip") {
    request.packageId = data.packageId;
  }

  if (data.description !== undefined) {
    request.description = data.description || null;
  }

  return request;
}
